import { DisplayText } from "js/elements/elements/DisplayText";
import { HeaderPositionType, ContentBlockType, TextBreakType } from "common/constants";
import { BaseElement } from "../base/BaseElement";
import { TextElement } from "../base/TextElement";
import * as geom from "js/core/utilities/geom";

export class Header extends DisplayText {
    get textAlign() {
        return this.styles.textAlign || "center";
    }

    get singleLineHeadline() {
        return this.position == HeaderPositionType.TOP;
    }

    get position() {
        return this.canvas.model.layout.headerPosition;
    }

    get selectionPadding() {
        return 10;
    }

    get isResizable() {
        return true;
    }

    // _build() {
    //     this.text = this.addElement("text", () => TextBlockContainer, {
    //         defaultBlockType: ContentBlockType.HEADING,
    //         defaultBlockTypes: [ContentBlockType.HEADING, ContentBlockType.BODY],
    //         allowedBlockTypes: [ContentBlockType.HEADLINE, ContentBlockType.HEADING, ContentBlockType.TITLE, ContentBlockType.BODY, ContentBlockType.CAPTION, ContentBlockType.LABEL],
    //         allowedBreakTypes: [TextBreakType.EVEN, TextBreakType.DEFAULT],
    //         autoWidth: false,
    //         autoHeight: true,
    //         scaleTextToFit: true
    //     });
    // }

    _loadStyles(styles) {
        styles.applyStyles(styles._position[this.position]);
        if (this.canvas.getTheme().get("styleDecoration") == "bar_left" && this.canvas.model.layout.trayLayout == "left_tray") {
            styles.applyStyles({ decoration: null });
            // TODO
        }
    }

    // _calcProps(props, options) {
    //     let { size, styles, children } = props;
    //
    //     let textProps = children.setProps(this.text, size);
    //     textProps.bounds = new geom.Rect(0, 0, textProps.size);
    //
    //     return { size: textProps.size };
    // }
}

export const elements = {
    Header
};
